export function formatLastSeen(value: string | null) {
  if (!value) return "Brak kontaktu";
  const elapsedMinutes = Math.max(
    0,
    Math.floor((Date.now() - new Date(value).getTime()) / 60_000),
  );
  if (elapsedMinutes < 2) return "Przed chwilą";
  if (elapsedMinutes < 60) return `${elapsedMinutes} min temu`;
  if (elapsedMinutes < 24 * 60) {
    return `${Math.floor(elapsedMinutes / 60)} godz. temu`;
  }
  return new Intl.DateTimeFormat("pl-PL", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

export function downloadBrowserFile({
  blob,
  filename,
}: {
  blob: Blob;
  filename: string;
}) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export function formatGrosz(value?: number) {
  if (value === undefined) return "—";
  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN",
    maximumFractionDigits: 2,
  }).format(value / 100);
}
